import { Component, inject, input } from "@angular/core";
import { Router } from "@angular/router";
import { IcEnvironment } from "@intocare-medapp/environment";

@Component({
	selector: "ic-problem",
	templateUrl: "./problem.component.html",
	styleUrls: ["./problem.component.scss"],
	standalone: false,
})
export class ProblemComponent {
	private icEnvironment = inject(IcEnvironment);
	private router = inject(Router);

	labelKey = input.required<string>();
	appVersion = this.icEnvironment.getEnvironment().APP_VERSION;

	private navigateToSelectOrganisation() {
		this.router.navigate(["select-organisation"]);
	}

	submit() {
		this.navigateToSelectOrganisation();
	}

	cancel() {
		this.navigateToSelectOrganisation();
	}
}
